import React from 'react';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

export function Buttons({ handlePublish, isLoading, isMobile }) {
    const navigate = useNavigate();

    const wrapperVisibility = isMobile ? 'flex md:hidden' : 'hidden md:flex';
    const positionClasses = isMobile
        ? 'sticky bottom-0'
        : 'fixed inset-x-0 bottom-0 z-[80] bg-[var(--background-white-color)]/95 border-t border-[#EDEDED] backdrop-blur-sm';

    return (
        <div
            className={`${wrapperVisibility} ${positionClasses} py-3`}
        >
            <div className="w-full max-w-[960px] mx-auto flex flex-col items-center gap-3 px-5 md:px-6">
                <h2 className="text-[18px] font-semibold m-0 text-center">
                    {t('previewTitle')}
                </h2>
                <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto justify-center">
                    <button
                        className="w-full sm:w-auto min-w-[160px] h-[40px] rounded-[10px] border-none cursor-pointer text-base font-medium bg-[var(--primary-color)] text-white flex items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed px-6"
                        onClick={handlePublish}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <div className="flex justify-center items-center w-full">
                                <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin" />
                            </div>
                        ) : (
                            t('publish')
                        )}
                    </button>
                    <button
                        className="w-full sm:w-auto min-w-[160px] h-[40px] rounded-[10px] border border-[var(--primary-color)] bg-transparent text-[var(--text-color)] cursor-pointer text-base font-medium flex items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed px-6"
                        disabled={isLoading}
                        onClick={() => navigate('/adform')}
                    >
                        {t('back')}
                    </button>
                </div>
            </div>
        </div>
    );
}